import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Results from './Results';
import Translator, { TranslationProvider } from './Translator';
import Navbar from './Navbar';
import About from './About';
import Contact from './Contact';
import Projects from './Projects';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import Chatbot from '@koppieesq/chatbot';
import { Link } from 'react-router-dom';

function App() {
  // Load apiUrl from environment variable.
  const apiUrl = process.env.REACT_APP_API_URL;
  return (
    <TranslationProvider>
    <Router>
      <div className="app">
         <header className="app-header">
           <h1 className='header'>
             <img className="header-logo" src="/logo.png"  alt="logo"/>
             <span className="header-title">Koplowicz & Sons</span>
           </h1>
           <Navbar />
         </header>

        <Translator />
        <Routes>
          <Route path="/chatbot" element={<Chatbot apiUrl={apiUrl} />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="*" element={<Results />} />
        </Routes>
        <footer className="app-footer">
          <Link to="/privacy">Privacy Policy</Link>
          <span aria-hidden="true"> · </span>
          <Link to="/terms">Terms of Service</Link>
        </footer>
       </div>
    </Router>
    </TranslationProvider>
  );
}

export default App;
